import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import { Cushion, Rectangle, Typography } from '@pitchero/react-ui';

const DateHeaderBar = ({ date }) => {
  const luxonDate = DateTime.fromISO(date);
  return (
    <Rectangle fill="alabaster">
      <Cushion
        horizontal="small"
        vertical="small"
        responsive={[{ minWidth: 'palm', props: { horizontal: 'medium' } }]}
      >
        <Typography preset="tag--large" color="black" component="div">
          {`${luxonDate.toFormat('LLLL')} `}
          <Typography preset="tag--large" color="dustygrey">
            {luxonDate.toFormat('yyyy')}
          </Typography>
        </Typography>
      </Cushion>
    </Rectangle>
  );
};

DateHeaderBar.propTypes = {
  date: PropTypes.string.isRequired,
};

export default DateHeaderBar;
